import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Input from "../../../../components/ui/inputs";
import { Block } from "../../main";
import { useEffect, useState } from "react";
import { useFormValidation } from "../../../../assets/utils/hooks/useFormsValidation";
import { validateAddMemberTeam } from "../../../../assets/utils/validation/form/validator-add-member-team";
import { ValidationFormsModeEnum } from "../../../../assets/utils/validation/form/types";
import toast from "react-hot-toast";
import CustomToast from "../../../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../../../assets/utils/enums/toast";
import { BodyDiv } from "../../../../components/components-style";
import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { CaptionText, MediumText } from "../../../../components/typography";
import { Button } from "../../../../components/ui/button";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { teamUsers } from "../../../../assets/utils/data/table/employees";

type ProfileOutletContext = {
    setLoaderState: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function UpdateMemberTeam() {
    const { id } = useParams();
    const { setLoaderState } = useOutletContext<ProfileOutletContext>();

    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [changedFirstName, setChangedFirstName] = useState<string>("");
    const [changedLastName, setChangedLastName] = useState<string>("");
    const [changedEmail, setChangedEmail] = useState<string>("");
    const [changedDescription, setChangedDescription] = useState<string>("");

    const [isChangedState, setIsChangedState] = useState<boolean>(false)
    const { errors, validate } = useFormValidation(validateAddMemberTeam);
    const navigate = useNavigate();

    useEffect(() => {
        if (id == null) return;
        const user = teamUsers.find(x => x.id === Number.parseInt(id));
        setFirstName(user?.fullName.split(" ")[0]!);
        setChangedFirstName(user?.fullName.split(" ")[0]!);
        setLastName(user?.fullName.split(" ")[1]!);
        setChangedLastName(user?.fullName.split(" ")[1]!);
        setEmail(user?.email!);
        setChangedEmail(user?.email!);
        setDescription(user?.description!);
        setChangedDescription(user?.description!);

    }, [id])

    const handleSave = async () => {
        try {
            setLoaderState(true);

            const { hasErrors } = validate(
                {
                    firstName, lastName, email
                },
                ValidationFormsModeEnum.EDIT
            );

            if (hasErrors) return;

            //   const response = await authFetch(`${API_URL_TASK}/create-task`, {
            //     method: "POST",
            //     headers: { "Content-Type": "application/json" },
            //     body: JSON.stringify({
            //       name: name,
            //       description: description,
            //       deadline: formatIOS(deadline),
            //       projectId: project.name === "" ? null : project.id,
            //       sellingId: selling.name === "" ? null : selling.id,
            //       priorityName: priority,
            //       users: members
            //         .filter((item) => item.email.trim() !== "")
            //         .map((item) => ({ email: item.email })),
            //     }),
            //     credentials: "include",
            //   });

            //   if (!response.ok) {
            //     toast((t) => (
            //       <CustomToast
            //         t={t}
            //         type={ToastTypeEnum.WARNING}
            //         text={"Перевірте коректність введення даних!"}
            //       />
            //     ));
            //     return;
            //   }
            toast((t) => (
                <CustomToast
                    t={t}
                    type={ToastTypeEnum.SUCCESS}
                    text={"Дані введені коректно, дані учасника відредаговано!"}
                />
            ));
            setTimeout(() => {
                navigate("/settings/team/view");
            }, 300);
        } catch (error) {
            console.error("Fetch error:", error);
            toast((t) => (
                <CustomToast
                    t={t}
                    text={"Упс, щось пішло не так\nПроблема з сервером."}
                    type={ToastTypeEnum.ERROR}
                />
            ));
        } finally {
            setTimeout(() => {
                setLoaderState(false);
            }, 150);
        }
    };

    useEffect(() => {
        function isChanged(
            editFirstName: string,
            editLastName: string,
            editEmail: string,
            editDescription: string,
        ) {
            if (
                editFirstName !== firstName ||
                editLastName !== lastName ||
                editEmail !== email ||
                editDescription !== description
            ) {
                setIsChangedState(true);
            } else {
                setIsChangedState(false);
            }
        }

        isChanged(changedFirstName, changedLastName, changedEmail, changedDescription);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changedFirstName, changedLastName, changedEmail, changedDescription]);


    return (
        <BodyDiv
            className={`${SETTINGS_BODY_DIV} justify-content-between gap-4`}
            $isPadding={true}
        >
            <Block
                className={`w-100 d-flex flex-column align-items-center gap-2`}
            >
                <CaptionText>Редагувати дані користувача</CaptionText>
                <div className="w-100">
                    <span className="w-100 d-flex gap-sm-3 flex-sm-row flex-column">
                        <Input
                            attribute="firstName"
                            value={changedFirstName}
                            setValue={setChangedFirstName}
                            errorText={errors.firstName}
                            label="Ім’я"
                            placeholder="Введіть ім’я"
                        />
                        <Input
                            attribute="lastName"
                            value={changedLastName}
                            setValue={setChangedLastName}
                            errorText={errors.lastName}
                            label="Прізвище"
                            placeholder="Введіть прізвище"
                        />
                    </span>
                    <Input
                        attribute="email"
                        value={changedEmail}
                        setValue={setChangedEmail}
                        errorText={errors.email}
                        label="Електронна пошта"
                        placeholder="Example@gmail.com"
                    />
                    <Input
                        attribute="description"
                        value={changedDescription}
                        setValue={setChangedDescription}
                        errorText={""}
                        label="Опис"
                        placeholder="Напишіть трішки інформації про учасника"
                    />
                </div>
            </Block>

            <Button
                bgcolor={COLORS.secondary1}
                txtcolor={COLORS.white}
                brcolor={COLORS.secondary1}
                type="large"
                width="40%"
                noactive={!isChangedState}
                disabled={!isChangedState}
                className="d-flex align-items-center gap-2"
                onClick={() => {
                    if (isChangedState) { handleSave(); }
                }}
            >
                <MediumText>Зберегти</MediumText>
            </Button>
        </BodyDiv>
    )
}
